import React, { useState } from "react";
import { ThinTextAreaField, ThinTextField } from "../../../../common/GeneralComponent";

const PlannedFields = ({ data }) => {
  const implementationDetails = data?.implementationDetails || {};
  // Extract relevant fields - note: attachments are at root level of data
  // const remarks = implementationDetails?.remarks || "No remarks available";
  const remarks = implementationDetails?.plan_remarks || "No remarks available";
  const planDate = implementationDetails?.plan_date || "";
  // Pre-condition image is at root level of data object
  const preConditionImage = data?.preConditionImage || null;

  // Image modal state
  const [showPreConditionModal, setShowPreConditionModal] = useState(false);

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "";
    const cleanPath = imagePath.replace(/^undefined\//, "");
    if (cleanPath.startsWith("http://") || cleanPath.startsWith("https://")) {
      return cleanPath;
    }
    const baseUrl = process.env.REACT_APP_BASE_URL || "";
    return `${baseUrl}/${cleanPath}`;
  };

  // Image modal handlers
  const handlePreConditionClick = (e) => { e.preventDefault(); e.stopPropagation(); if (preConditionImage) setShowPreConditionModal(true); };
  const closePreConditionModal = (e) => { e?.stopPropagation(); setShowPreConditionModal(false); };

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        {/* Plan Date */}
        {planDate && (
          <div className="w-full">
            <ThinTextField isRequired={false} label="Planned Date" value={new Date(planDate).toLocaleDateString()} disabled />
          </div>
        )}
        {/* Remarks - span 2 columns to balance */}
        <div className="w-full md:col-span-2">
          <ThinTextAreaField isRequired={false} label="Remarks / Details" value={remarks} disabled />
        </div>
        {!planDate && <div className="w-full"></div>} {/* Balance if no date */}
      </div>
      {/* Pre-condition Picture */}
      {preConditionImage && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div className="w-full">
            <label className="text-sm font-[Regular] text-[#565656] p-2 mb-1 block">Pre-Condition Picture</label>
            <div className="border border-gray-300 rounded-md p-2 bg-gray-50 h-[42px] flex items-center">
              <button onClick={handlePreConditionClick} className="flex items-center gap-2 cursor-pointer hover:bg-blue-50 px-2 py-1 rounded transition-all duration-200 border border-transparent hover:border-blue-200 w-full text-left min-h-0">
                <i className="fa fa-image text-blue-500 text-sm flex-shrink-0"></i>
                <span className="text-xs text-blue-600 hover:text-blue-800 font-medium truncate">Pre-Condition Image</span>
                <i className="fa fa-eye text-xs text-blue-400 flex-shrink-0 ml-auto"></i>
              </button>
            </div>
          </div>
          <div className="w-full"></div>
          <div className="w-full"></div>
        </div>
      )}

      {/* PreCondition Image Modal */}
      {showPreConditionModal && preConditionImage && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[9999]" onClick={closePreConditionModal}>
          <div className="relative bg-white rounded-lg shadow-lg p-4 max-w-3xl max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
            <button onClick={closePreConditionModal} className="absolute top-2 right-2 text-gray-600 hover:text-black">✕</button>
            <h2 className="text-center text-gray-800 mb-3 text-lg font-semibold">Pre-Condition Picture</h2>
            <img src={getImageUrl(preConditionImage)} alt="Pre-Condition Picture" className="max-h-[80vh] object-contain rounded-md border border-gray-300" onError={(e) => { e.target.onerror = null; e.target.src = "https://via.placeholder.com/600x400?text=Image+not+found"; }} />
            <a href={getImageUrl(preConditionImage)} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700 text-sm underline mt-2 text-center">View Full Image</a>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlannedFields;